export default "__VITE_ASSET__xnibvnmZ__"